export default __webpack_public_path__ + "static/media/desktop.4d704285.jpg";